import React, { useState, useEffect } from "react";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";

const AdminPrintCurrentOrderiInfo = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="table-icon">
        <PrintIcon
          onClick={() =>
            navigate(
              `/print-current-provider-order-report-details/${props.selectedRow?.id}`
            )
          }
        />
      </div>
    </>
  );
};

export default AdminPrintCurrentOrderiInfo;
